import { render, staticRenderFns } from "./XDictSelectTag.vue?vue&type=template&id=d7c38f1c&scoped=true&"
import script from "./XDictSelectTag.vue?vue&type=script&lang=js&"
export * from "./XDictSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c38f1c",
  null
  
)

export default component.exports